import AlectifyMap from "./alectifyMap";

export default AlectifyMap;
